import React, { useEffect } from "react";
import { Platform } from "react-native";
import * as Sentry from "@sentry/react-native";
import { isNativeFaceCaptureAvailable } from "@utils/nativeFaceCapture";
import { NativeFaceCaptureController } from "./NativeFaceCaptureController";

/**
 * App-root face capture (mounted in src/index.js). The screen itself is the
 * native FaceCaptureActivity; this only decides whether to mount the
 * controller that drives it.
 *
 * FaceCaptureModule ships in every binary from the native face-capture
 * release onward, so a missing module means this JS bundle was CodePushed to
 * an older APK. Nothing can be shown in that case — the RN modal is gone —
 * so report it: a mandatory capture would otherwise never appear.
 */
export default function FaceCapture() {
  const available = isNativeFaceCaptureAvailable();

  useEffect(() => {
    if (!available && Platform.OS === "android") {
      Sentry.captureMessage(
        "FaceCaptureModule missing: JS bundle running on a binary without native face capture",
        "error",
      );
    }
  }, [available]);

  if (!available) return null;
  return <NativeFaceCaptureController />;
}
